module.exports = __webpack_public_path__ + "static/Icons_ReverseMortgage_active-f9e18b8bc3bb570d3e9a0d93f55fdb78.png";